var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 14V9.33333C22.6667 8.6 22.0667 8 21.3333 8H5.33333C4.6 8 4 8.6 4 9.33333V22.6667C4 23.4 4.6 24 5.33333 24H21.3333C22.0667 24 22.6667 23.4 22.6667 22.6667V18L28 23.3333V8.66667L22.6667 14ZM18.6667 17.3333H14.6667V21.3333H12V17.3333H8V14.6667H12V10.6667H14.6667V14.6667H18.6667V17.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendar);
export default __webpack_public_path__ + "static/media/agendar.437356e25a7f0adb77be44ae14f64a9a.svg";
export { ForwardRef as ReactComponent };